import RelatedRoutes from './RelatedRoutes';
export default RelatedRoutes;
